module.exports = global["FloatingNavigationHelpers"] = require("-!/export/apps/mobile/node_modules/babel-loader/lib/index.js??ref--12-0!./helpers.js");